<template>
  <!-- 首页页面 -->
  <div>
    <!-- PC端 -->
    <div class="home" v-if="webFlag">
      <!-- 轮播图 -->
      <el-carousel :interval="2000" arrow="always" autoplay>
        <head-nav />
        <!-- 头部 -->
        <el-carousel-item v-for="(item, i) in bannerList" :key="i">
          <img :src="item.content" alt="" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
      <!-- 主体 -->
      <section class="content">
        <el-row class="abuot_us">
          <el-col :span="24" style="text-align: left">
            <el-row class="title">凌顶校园安全管理平台</el-row>
            <el-row class="eng mg">LING DING</el-row>
            <el-row class="blue"></el-row>
          </el-col>
          <el-col
            :span="24"
            style="
              margin: 20px 0;
              background: #fff;
              width: 100%;
              padding: 90px 30px 30px;
              box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
            "
          >
            <el-row style="display: flex; justify-content: space-between">
              <el-col :span="10">
                <img src="@/assets/images/img001.png" alt="" height="100%" />
              </el-col>
              <el-col :span="4"></el-col>
              <el-col
                :span="10"
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <div
                  style="
                    font-size: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #808080;
                    line-height: 30px;
                    text-indent: 2em;
                    text-align: left;
                  "
                >
                  凌顶校园安全智能化管理平台基于我公司多年教育行业经验积累和技术能力的发展，对校园的智能化建设，实现校园物联设备全覆盖，实现校园全节点、全场景的智能互联，并在智能物联化的基础上，融合校园多个信息网系统应用，实现物信融合统一管理，不但使管理的粒度更精细，使校园的管理更全面、更方便、更可靠、更简单，使学校的服务更贴近师生的需求和使用。通过AI赋能，提升数据价值，通过物信融合在校园安全、师生服务、后勤管理方面提升业务突破能力，构建智安、便捷、绿色的校园新格局。实现校园设施物联化、校园安防智能化、校园生活便捷、校园管理科学化。
                </div>
                <el-row>
                  <img src="@/assets/images/img002.png" alt="" width="80%" />
                </el-row>
              </el-col>
            </el-row>
            <div class="more">
              <span>了解更多</span>
              <img
                src="../assets/images/icon__home_more.png"
                alt=""
                @click="moreEvent"
              />
            </div>
          </el-col>
        </el-row>
        <el-row class="solu">
          <div class="white">
            <div class="contener">
              <el-row
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  text-align: left;
                  color: #ffffff;
                "
                >解决方案</el-row
              >
              <el-row
                style="
                  font-size: 16px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #ffffff;
                  text-align: left;
                "
                class="mg"
                >SOLUTION</el-row
              >
              <div class="outer-container">
                <el-row class="card_part">
                  <!-- <div
                    v-for="(item, i) in programList"
                    :key="i"
                    class="item_card"
                  >
                    <img :src="item.url" alt="" />
                    <h2>{{ item.title }}</h2>
                    <p>{{ item.tip }}</p>
                    <el-button class="det" @click="faEvent">了解详情</el-button>
                  </div> -->
                  <div class="item_card">
                    <img
                      src="@/assets/images/icon_home_introduce02.png"
                      alt=""
                    />
                    <h2>安全专项管理</h2>
                    <p>
                      提高学生的安全预防意识,实现校园安全网格化管理与实时化监管,提升校园安全管理水平。
                    </p>
                    <el-button class="det" @click="faEvent">了解详情</el-button>
                  </div>
                  <div class="item_card">
                    <img src="@/assets/images/icon_home_culture02.png" alt="" />
                    <h2>应急管理</h2>
                    <p>
                      提升学校对突发事件的应急管理能力，及时有效地作出应急措施。
                    </p>
                    <el-button class="det" @click="faEvent">了解详情</el-button>
                  </div>
                  <div class="item_card">
                    <img src="@/assets/images/icon_home_daily02.png" alt="" />
                    <h2>日常安全管理</h2>
                    <p>让校园的日常安全管理更高效、更便捷。</p>
                    <el-button class="det" @click="faEvent">了解详情</el-button>
                  </div>
                  <div class="item_card">
                    <img
                      src="@/assets/images/icon_home_interaction02.png"
                      alt=""
                    />
                    <h2>智慧教务</h2>
                    <p>
                      将学校的教学教务工作数字化、网络化、多媒体化，改变传统的教学模式，实现教育的智能化、现代化。
                    </p>
                    <el-button class="det" @click="faEvent">了解详情</el-button>
                  </div>
                  <div class="item_card">
                    <img
                      src="@/assets/images/icon_home_platform02.png"
                      alt=""
                    />
                    <h2>信息看板</h2>
                    <p>
                      将所有数据进行统计分析，让数据分析结果形象、直观地呈现，功能模块间实现交互式常规式可视化导览。
                    </p>
                    <el-button class="det" @click="faEvent">了解详情</el-button>
                  </div>
                  <div class="item_card">
                    <img src="@/assets/images/icon_home_product02.png" alt="" />
                    <h2>前端产品</h2>
                    <p>智能安全终端</p>
                    <el-button class="det" @click="faEvent">了解详情</el-button>
                  </div>
                </el-row>
              </div>
            </div>
          </div>
        </el-row>
        <el-row class="project_case">
          <el-col :span="24" class="left_tip">
            <el-row class="title">项目案例</el-row>
            <el-row class="eng mg">PROJECT CASES</el-row>
            <el-row class="blue"></el-row>
            <div class="school_List">
              <div class="item_school" v-for="(item, i) in sampleList" :key="i">
                <img :src="item.url" alt="" />
                <div class="school_name">{{ item.title }}</div>
                <div class="marsk">
                  <div class="link" @click="caseMore">
                    <img
                      src="../assets/images/icon_more01.png"
                      alt=""
                      style="width: 38px; height: 38px"
                    />
                    <p
                      style="
                        font-size: 18px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #f7f8fb;
                      "
                    >
                      查看更多
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="news_center">
          <el-col :span="24" class="left_tip">
            <el-row class="title">新闻中心</el-row>
            <el-row class="eng mg">PROGRAM ADAVNTAGES</el-row>
            <el-row class="blue"></el-row>
            <div class="news_List">
              <div class="itemes" v-for="(item, i) in newsList.slice(0,3)" :key="i">
                <div class="item_news">
                  <img :src="item.url" alt="" />
                  <div class="news_right">
                    <div class="news_title">{{ item.title }}</div>
                    <div class="matter" v-html="item.content"></div>
                  </div>
                </div>
                <div class="time">
                  <span>{{ item.createData }}</span>
                  <img src="../assets/images/icon_home_news01.png" alt="" />
                </div>
              </div>
            </div>
            <el-button class="read_more" @click="newsMore">查看更多</el-button>
          </el-col>
        </el-row>
        <el-row class="online_msg">
          <el-col :span="24" class="left_tip">
            <el-row class="title">在线留言</el-row>
            <el-row class="eng mg">ONLINE MESSAGE</el-row>
            <el-row class="blue"></el-row>
            <el-row class="inp">
              <el-col :span="5">
                <el-input
                  v-model="name"
                  placeholder="您的姓名"
                  style="width: 60%"
                ></el-input>
              </el-col>
              <el-col :span="5">
                <el-input
                  v-model="phoneNumber"
                  placeholder="您的手机号码"
                  style="width: 60%"
                ></el-input>
              </el-col>
              <el-col :span="9">
                <el-input
                  v-model="msg"
                  placeholder="您的留言"
                  style="width: 80%"
                ></el-input>
              </el-col>
              <el-col :span="5">
                <el-button class="sub" @click="submit">提交</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </section>
      <!-- 尾部 -->
      <footer-com />
    </div>
    <!-- 移动端 -->
    <div class="home" v-if="mobilPhoneFlag">
      <!-- 头部 -->
      <mobileHead></mobileHead>
      <el-carousel :interval="2000" arrow="always" autoplay>
        <el-carousel-item v-for="(item, i) in bannerList" :key="i">
          <img :src="item.content" alt="" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
      <el-container>
        <el-aside width="100%">
          <div class="about_us">
            <el-row class="title">凌顶校园安全管理平台</el-row>
            <el-row class="eng mg">LING DING</el-row>
            <el-row class="blue"></el-row>
            <div class="text">
              凌顶校园安全智能化管理平台基于我公司多年教育行业经验积累和技术能力的发展，对校园的智能化建设，实现校园物联设备全覆盖，实现校园全节点、全场景的智能互联，并在智能物联化的基础上，融合校园多个信息网系统应用，实现物信融合统一管理，不但使管理的粒度更精细，使校园的管理更全面、更方便、更可靠、更简单，使学校的服务更贴近师生的需求和使用。通过AI赋能，提升数据价值，通过物信融合在校园安全、师生服务、后勤管理方面提升业务突破能力，构建智安、便捷、绿色的校园新格局。实现校园设施物联化、校园安防智能化、校园生活便捷、校园管理科学化。
            </div>
          </div>
          <div class="solu">
            <el-row
              style="
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                text-align: left;
                color: #ffffff;
              "
              >解决方案</el-row
            >
            <el-row
              style="
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ffffff;
                text-align: left;
                margin: 5px 0;
              "
              class="mg"
              >SOLUTION</el-row
            >
            <el-row
              style="width: 10px; height: 2px; background: #ffffff"
            ></el-row>
          </div>
          <div class="white">
            <img src="@/assets/images/img011.png" alt="" />
            <el-button class="faBtn" @click="faEvent">了解详情</el-button>
          </div>
          <div class="project_case">
            <el-row class="title">项目案例</el-row>
            <el-row class="eng mg">PROJECT CASES</el-row>
            <el-row class="blue"></el-row>
            <div class="school_List">
              <div class="item_school" v-for="(item, i) in sampleList" :key="i">
                <img :src="item.url" alt="" />
                <div class="school_name">{{ item.title }}</div>
              </div>
            </div>
            <el-button @click="caseMore" class="xmBtn">更多案例</el-button>
          </div>
          <div class="news_center">
            <el-row class="title">新闻中心</el-row>
            <el-row class="eng mg">PROGRAM ASVANTAGES</el-row>
            <el-row class="blue"></el-row>
            <div class="news_List">
              <div class="itemes" v-for="(item, i) in newsList" :key="i">
                <div class="item_news">
                  <img :src="item.url" alt="" />
                </div>
                <div class="news_right">
                  <div class="news_title">{{ item.title }}</div>
                  <div class="matter" v-html="item.content"></div>
                  <div class="time">
                    <span>{{ item.createData }}</span>
                    <img src="../assets/images/icon_home_news01.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <el-button class="read_more" @click="newsMore">查看更多</el-button>
          </div>
          <div class="online_msg">
            <el-row class="title">在线留言</el-row>
            <el-row class="eng mg">ONLINE MESSAGE</el-row>
            <el-row class="blue"></el-row>
            <el-input
              v-model="name"
              placeholder="您的姓名"
              style="width: 100%"
            ></el-input>
            <el-input
              v-model="phoneNumber"
              placeholder="您的手机号码"
              style="width: 100%"
            ></el-input>
            <el-input
              v-model="msg"
              placeholder="您的留言"
              style="width: 100%"
            ></el-input>
            <el-button class="sub" @click="submit">提交</el-button>
          </div>
        </el-aside>
      </el-container>
      <mobile-footer></mobile-footer>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/header.vue";
import footerCom from "@/components/footer.vue";
// 移动端组件
import mobileHead from "@/components/publicCom/mobileHead.vue";
import mobileFooter from "@/components/publicCom/mobileFooter.vue";
export default {
  components: {
    headNav,
    footerCom,
    mobileHead,
    mobileFooter,
  },
  data() {
    return {
      // programList: [
      //   {
      //     url: require("@/assets/images/icon_home_introduce01.png"),
      //     title: "安全专项管理",
      //     tip: "提高学生的安全预防意识,实现校园安全网格化管理与实时化监管,提升校园安全管理水平。",
      //   },
      //   {
      //     url: require("@/assets/images/icon_home_culture02.png"),
      //     title: "应急管理",
      //     tip: "提升学校对突发事件的应急管理能力，及时有效地作出应急措施。",
      //   },
      //   {
      //     url: require("@/assets/images/icon_home_daily02.png"),
      //     title: "日常安全管理",
      //     tip: "让校园的日常安全管理更高效、更便捷。",
      //   },
      //   {
      //     url: require("@/assets/images/icon_home_interaction02.png"),
      //     title: "智慧教务",
      //     tip: "将学校的教学教务工作数字化、网络化、多媒体化，改变传统的教学模式，实现教育的智能化、现代化。",
      //   },
      //   {
      //     url: require("@/assets/images/icon_home_platform02.png"),
      //     title: "信息看板",
      //     tip: "将所有数据进行统计分析，让数据分析结果形象、直观地呈现，功能模块间实现交互式常规式可视化导览。",
      //   },
      //   {
      //     url: require("@/assets/images/icon_home_product02.png"),
      //     title: "前端产品",
      //     tip: "智能安全终端",
      //   },
      // ],
      name: "",
      phoneNumber: "",
      msg: "",
      bannerList: "",
      sampleList: "",
      newsList: "",
      webFlag: true,
      mobilPhoneFlag: false,
    };
  },
  created() {
    this.getListHomeAll();
    this.getListSampleAll();
    this.getListNewsAll();
    this.getScreenWidth();
  },
  methods: {
    // 获取当前设备宽度
    getScreenWidth() {
      console.log(document.body.offsetWidth, window.screen.availWidth);
      if (window.screen.availWidth <= 1366) {
        this.webFlag = false;
        this.mobilPhoneFlag = true;
        console.log(window.screen.availWidth);
      }
    },
    moreEvent() {
      this.$router.push({ path: "/aboutUs" });
    },
    newsMore() {
      this.$router.push({ path: "/newsCenter" });
    },
    // 获取内容列表
    getListHomeAll() {
      this.$axios
        .get("/content/home/listAll")
        .then((res) => {
          this.bannerList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取案例列表
    getListSampleAll() {
      this.$axios
        .get("/content/sample/listAll")
        .then((res) => {
          console.log(res);
          this.sampleList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getListNewsAll() {
      this.$axios.get("/content/content/listAll/1").then((res) => {
        console.log(res);
        this.newsList = res.data;
      });
    },
    // 项目案例查看更多
    caseMore() {
      this.$router.push({
        path: "/caseAndUse",
      });
    },
    // 提交
    submit() {
      //var name = this.name.replace(/\s/g," ");
      //console.log(name);
      if(this.name == ""){
        this.$message({
          message: "姓名不能为空",
          type: "error",
        });
        return;
      }
      if(this.phoneNumber == ""){
        this.$message({
          message: "手机号不能为空",
          type: "error",
        });
        return;
      }
      if(this.msg == ""){
        this.$message({
          message: "留言不能为空",
          type: "error",
        });
        return;
      }
      let obj = {
        name: this.name,
        phone: this.phoneNumber,
        content: this.msg,
      };
      this.$axios.post("/content/message/addMessageInfo", obj).then((res) => {
        this.$message({
          message: "留言成功",
          type: "success",
        });
      });
      console.log(obj);
    },
    // 方案了解更多
    faEvent() {
      this.$router.push({
        path: "/solution",
      });
    },
  },
};
</script>

<style lang="scss" >
@media screen and (min-width: 1367px) {
  .home {
    width: 100%;
  }
  .el-carousel {
    height: 100vh;
    .el-carousel__container {
      height: 100%;
      .el-carousel__item {
        height: 100%;
        img {
          height: 100%;
        }
      }
    }
  }
  .content {
    .title {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
    }
    .eng {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .blue {
      width: 20px;
      height: 4px;
      background: #3660d9;
    }
    .abuot_us {
      margin: 129px 160px;
      .more {
        width: 100%;
        margin: 20px 0 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        span {
          font-size: 16px;
          font-weight: 400;
          color: #4d4d4d;
          line-height: 24px;
        }
        img {
          margin-left: 20px;
        }
      }
    }
    .solu {
      height: 600px;
      background-image: url("../assets/images/bg02.png");
      width: 100%;
    }
  }
  .left_tip {
    text-align: left;
  }
  .mg {
    margin: 20px 0;
  }

  .white {
    margin: 0 3%;
    background: white;
    height: 600px;
    position: relative;
    top: 40%;
    left: 0;
    .contener {
      margin: 0 120px;
      position: relative;
      top: -190px;
      left: 0;
      .outer-container {
        position: relative;
        width: 100%;
        // background: red;
        height: 590px;
        overflow: hidden;
      }
      .card_part {
        width: 100%;
        margin-top: 10%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .item_card {
          width: 200px;
          // width:14%;
          padding: 4% 1%;
          background: #fff;
          box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
          margin: 0 10px 30px;
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #000000;
            line-height: 24px;
            opacity: 0.6;
            // text-align: left;
            margin: 20px 0;
            min-height: 100px;
          }
          .det {
            width: 140px;
            height: 50px;
            background: #3660d9;
            border-radius: 6px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .card_part > .item_card:nth-child(1):hover img {
        content: url("../assets/images/icon_home_introduce01.png");
      }
      .card_part > .item_card:nth-child(2):hover img {
        content: url("../assets/images/icon_home_culture01.png");
      }
      .card_part > .item_card:nth-child(3):hover img {
        content: url("../assets/images/icon_home_daily01.png");
      }
      .card_part > .item_card:nth-child(4):hover img {
        content: url("../assets/images/icon_home_interaction01.png");
      }
      .card_part > .item_card:nth-child(5):hover img {
        content: url("../assets/images/icon_home_platform01.png");
      }
      .card_part > .item_card:nth-child(6):hover img {
        content: url("../assets/images/icon_home_product01.png");
      }
    }
  }
  .project_case {
    margin: 314px 160px 0;
    .school_List {
      margin: 5% 0 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      max-height: 600px;
      overflow: hidden;
      .item_school {
        width: 500px;
        height: 280px;
        text-align: center;
        background: white;
        margin-bottom: 30px;
        box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #808080;
        position: relative;
        img {
          width: 100%;
          height: 75%;
        }
        .school_name {
          width: 100%;
          height: 25%;
          line-height: 60px;
        }
        .marsk {
          width: 100%;
          height: 75%;
          background: rgba(0, 0, 0, 0.3);
          position: absolute;
          top: 0;
          left: 0;
          display: none;
          text-align: center;
          .link {
            width: 100px;
            height: 100px;
            margin: 55px auto;
          }
        }
      }
      .item_school:hover {
        background: #3660d9;
        color: #fff;
      }
      .item_school:hover .marsk {
        display: block;
      }
    }
  }
  .news_center {
    margin: 120px 160px 0;
    .news_List {
      margin: 7% 0 0;
      display: flex;
      justify-content: space-between;
      max-height: 300px;
      overflow: hidden;
      .itemes {
        width: 30%;
        .item_news {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 0 20px;
          border-bottom: 2px solid #4e4d4e;
          border-bottom-color: rgba(78, 77, 78, 0.3);
          margin-bottom: 25px;
          img {
            width: 170px;
            height: 128px;
          }
          .news_right {
            width: 60%;

            .news_title {
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #3660d9;
              letter-spacing: 0;
              margin-bottom: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .matter {
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #3660d9;
              line-height: 30px;
              opacity: 0.5;
              letter-spacing: 0;
              overflow: hidden;
              min-height: 120px;
              max-height: 120px;
              text-indent: 2em;
              text-align: left;
            }
          }
        }
      }
    }

    .read_more {
      width: 292px;
      height: 60px;
      background: #3660d9;
      border-radius: 6px;
      margin: 65px 40%;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
    }
    .time {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .online_msg {
    margin: 120px 160px 0;
    .inp {
      margin: 70px 0 184px;
      .el-input__inner {
        background: #ececec;
        border: none;
        height: 60px;
      }
      .sub {
        width: 292px;
        height: 60px;
        background: #3660d9;
        border-radius: 6px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .home {
    width: 100%;
    .el-carousel {
      margin-top: 90px;
      height: 313px;
      .el-carousel__button {
        width: 24px;
      }
      .el-carousel__container {
        height: 100%;
        .el-carousel__item {
          height: 100%;
          img {
            height: 100%;
          }
        }
      }
    }

    .about_us {
      padding: 30px;
      background: #fff;
      margin: 20px 0;
      .text {
        background-image: url("../assets/images/logo011.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 45%;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #808080;
        line-height: 36px;
        text-indent: 2em;
        text-align: left;
      }
    }
    .solu {
      width: calc(100% - 60px);
      height: 300px;
      padding: 30px;
      background-image: url("../assets/images/bg02.png");
      background-size: cover;
    }
    .white {
      width: 100%;
      height: 300px;
      background: #fff;
      position: relative;
      top: -200px;
      left: 0;
      z-index: 999;
      width: 80%;
      margin: 0 auto;
      img {
        width: 80%;
        margin: 20px auto;
      }
      .faBtn {
        width: 180px;
        height: 50px;
        background: #3660d9;
        border-radius: 6px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 38px;
        padding: 5px 10px;
        margin-top: 10px;
      }
    }
    .project_case {
      // width: 100%;
      padding: 30px;
      background: #fff;
      margin: 0;
      .school_List {
        margin: 5% 0 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        height: 500px;
        overflow: hidden;
        margin: 20px 0;
        .item_school {
          width: 48%;
          background: #ffffff;
          box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 183px;
          }
          .school_name {
            height: 50px;
            line-height: 50px;
          }
        }
      }
      .xmBtn {
        width: 180px;
        height: 50px;
        background: #3660d9;
        border-radius: 6px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 38px;
        padding: 5px 10px;
        margin-top: 10px;
      }
    }
    .news_center {
      padding: 30px;
      background: #fff;
      margin: 0 0 20px;
      .news_List {
        width: 100%;
        max-height: 900px;
        overflow: hidden;
        .itemes {
          background: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 20px 0;
          padding: 0 0 10px;
          border-bottom: 1px solid #999;
          .item_news {
            width: 30%;
          }
          .news_right {
            width: 69%;
            text-align: left;
            .news_title {
              font-size: 22px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #2f2f2f;
              line-height: 48px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .matter {
              height: 120px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #808080;
              line-height: 30px;
              margin: 20px 0;
            }
            .time {
              display: flex;
              justify-content: space-between;
              span {
                font-size: 20px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #3660d9;
                line-height: 38px;
                opacity: 0.5;
              }
              img {
                width: 24px;
                height: 24px;
              }
            }
          }
        }
      }
      .read_more {
        width: 180px;
        height: 50px;
        background: #3660d9;
        border-radius: 6px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 38px;
        padding: 5px 10px;
        margin-top: 10px;
      }
    }

    .online_msg {
      background: #fff;
      padding: 30px;
      margin: 0 0 20px;
      .el-input__inner {
        width: 100%;
        margin: 20px 0;
        background: #ececec;
        input::-webkit-input-placeholder {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
          opacity: 0.5;
        }
      }
      .sub {
        width: 180px;
        height: 50px;
        background: #3660d9;
        border-radius: 6px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 38px;
        padding: 5px 10px;
        margin-top: 10px;
        border-radius: 10px;
      }
    }
  }
}
.title {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  text-align: left;
}
.eng {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin: 10px 0;
}
.blue {
  width: 20px;
  height: 4px;
  background: #3660d9;
}
</style>


// WEBPACK FOOTER //
// src/views/homePage.vue